import React from 'react'
import fetch from 'node-fetch'

import SegmentsPopupContent from '../../../../src/commons/components/SegmentsPopupContent'
import './SegmentDocument.less'

import { page } from 'web-commons-export/documents'

export default {
  documentName: 'segment',
  documentCreator: async function (authorizationHeader) {
    let data = await getDataAsync(authorizationHeader)
    let pages = [Page1, Page2]
    return {
      pages,
      data,
    }
  }
}

async function getDataAsync (authorizationHeader) {
  const headers = {
    'authorization': authorizationHeader
  }
  return fetch('http://localhost:6200/dmp/entities', {headers})
    .then(res => res.json())
}

@page({title: 'SEGMENT REPORT', bodyText: 'segment #701'})
class Page1 {
  constructor (data) {
    this.data = data
  }

  getMainContent () {
    const data = this.data
    return (
      <div>
        <SegmentsPopupContent
          hidePopup={() => {}}
          platformData={{
            'id': 701,
            'reach': 16000000,
            'count': 150000000
          }}
        />
      </div>
    )
  }
}

@page({bodyText: 'page 2 text body'})
class Page2 {
  constructor (data) {
    this.data = data
  }

  getCustomContent (slide) {
    const data = this.data
    slide.addText('Page 2 - Manual Title ' + data.title, {
      x: '50%',
      y: 0.25,
      font_size: 18,
      font_face: 'Arial',
      color: 'FF0000'
    })
  }

  getMainContent () {
    const data = this.data

    return (
      <div>
        <span>{JSON.stringify(data).substring(0, 300)}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/documents/SegmentDocument/SegmentDocument.js